import { useMemo } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import Grid from '@mui/material/Grid2';
import { Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { IPhotographerBookingData } from 'api';
import { useLocalization } from 'localization';
import { BookingFormData } from 'components/v2/division/form/schema/createOrderSchema';

type TimeSelectorProps = {
  availableDates: IPhotographerBookingData['start'][];
  disabled?: boolean;
};

const TimeSelector = (props: TimeSelectorProps) => {
  const { availableDates, disabled } = props;
  const { f } = useLocalization();
  const { watch, setValue } = useFormContext<BookingFormData>();

  const selectedTime = watch('selectedTime');

  const timeOptions = useMemo(() => {
    const result: Dayjs[] = [];
    const start = dayjs('08:00', 'HH:mm');
    const end = dayjs('17:00', 'HH:mm');

    const steps = end.diff(start, 'hour');

    for (let i = 0; i <= steps; i++) {
      result.push(start.add(i, 'hour'));
    }

    return result;
  }, []);

  return (
    <Grid container columnSpacing={1} rowSpacing={1.25}>
      {timeOptions.map((option, index) => {
        const isSelected = selectedTime ? selectedTime.hour() === option.hour() : false;
        return (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
            <Button
              disabled={!availableDates.find(date => dayjs(date).get('hours') === option.get('hours')) || disabled}
              sx={{ minWidth: 'fit-content' }}
              fullWidth
              variant={isSelected && !disabled ? 'contained' : 'outlined'}
              onClick={() => setValue('selectedTime', option)}
            >
              {f(option.toDate(), { time: 'short' })}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TimeSelector;
